"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersionSource = exports.VersionState = exports.YamlFileNamesV4 = exports.YamlFileNamesV3 = exports.YamlFileNames = exports.MetadataV4 = exports.MetadataV3Abandoned = exports.MetadataV2 = exports.MetadataV3 = void 0;
exports.isYamlFileName = isYamlFileName;
exports.isYamlFileNameV3 = isYamlFileNameV3;
exports.isYamlFileNameV4 = isYamlFileNameV4;
/**
 * @author xzf0587 <zhaofengxu@microsoft.com>
 */
const os_1 = require("os");
exports.MetadataV3 = {
    projectVersion: "1.0.0",
    unSupprotVersion: "2.0.0",
    platformVersion: {
        vs: "17.5.x.x",
        vsc: "5.x.x",
        cli: "2.x.x",
        cli_help: "2.x.x",
    },
    configFile: "teamsapp.yml",
    localConfigFile: "teamsapp.local.yml",
    testToolConfigFile: "teamsapp.testtool.yml",
    sandboxConfigFile: "teamsapp.sandbox.yml",
    defaultEnvironmentFolder: "env",
    envFilePrefix: ".env",
    secretFileSuffix: "user",
    projectId: "projectId",
    teamsManifestFolder: "appPackage",
    teamsManifestFileName: "manifest.json",
    aadManifestFileName: "aad.manifest.json",
    v3UpgradeWikiLink: "https://aka.ms/teams-toolkit-5.0-upgrade",
    secretFileComment: "# This file includes environment variables that will not be committed to git by default. You can set these environment variables in your CI/CD system for your project." +
        os_1.EOL,
    secretComment: "# Secrets. Keys prefixed with `SECRET_` will be masked in Microsoft 365 Agents Toolkit logs." +
        os_1.EOL,
    envFileDevComment: "# This file includes environment variables that will be committed to git by default." + os_1.EOL,
    envFileLocalComment: "# This file includes environment variables that can be committed to git. It's gitignored by default because it represents your local development environment." +
        os_1.EOL,
};
exports.MetadataV2 = {
    projectVersion: "2.0.0",
    projectMaxVersion: "2.1.0",
    platformVersion: {
        vs: "17.4.x.x",
        vsc: "4.x.x",
        cli: "1.x.x",
        cli_help: "1.x.x",
    },
    configFolder: ".fx",
    stateFolder: "states",
    userdataSuffix: "userdata",
    configFile: "projectSettings.json",
    updateToolkitLink: "https://aka.ms/update-teams-toolkit",
    aadTemplateFileName: "aad.template.json",
};
exports.MetadataV3Abandoned = {
    projectVersion: "3.0.0",
    configFolder: "teamsfx",
    configFile: "settings.json",
};
exports.MetadataV4 = {
    configFile: "m365agents.yml",
    localConfigFile: "m365agents.local.yml",
    testToolConfigFile: "m365agents.playground.yml",
    sandboxConfigFile: "m365agents.sandbox.yml",
};
exports.YamlFileNames = [
    exports.MetadataV3.configFile,
    exports.MetadataV3.localConfigFile,
    exports.MetadataV3.testToolConfigFile,
    exports.MetadataV3.sandboxConfigFile,
    exports.MetadataV4.configFile,
    exports.MetadataV4.localConfigFile,
    exports.MetadataV4.testToolConfigFile,
    exports.MetadataV4.sandboxConfigFile,
];
exports.YamlFileNamesV3 = [
    exports.MetadataV3.configFile,
    exports.MetadataV3.localConfigFile,
    exports.MetadataV3.testToolConfigFile,
    exports.MetadataV3.sandboxConfigFile,
];
exports.YamlFileNamesV4 = [
    exports.MetadataV4.configFile,
    exports.MetadataV4.localConfigFile,
    exports.MetadataV4.testToolConfigFile,
    exports.MetadataV4.sandboxConfigFile,
];
function isYamlFileName(fileName) {
    return exports.YamlFileNames.includes(fileName);
}
function isYamlFileNameV3(fileName) {
    return exports.YamlFileNamesV3.includes(fileName);
}
function isYamlFileNameV4(fileName) {
    return exports.YamlFileNamesV4.includes(fileName);
}
var VersionState;
(function (VersionState) {
    // project version compatible
    VersionState[VersionState["compatible"] = 0] = "compatible";
    // project version outdated, project should upgrade
    VersionState[VersionState["upgradeable"] = -1] = "upgradeable";
    // project version ahead, need update toolkit
    VersionState[VersionState["unsupported"] = 1] = "unsupported";
})(VersionState || (exports.VersionState = VersionState = {}));
var VersionSource;
(function (VersionSource) {
    VersionSource[VersionSource["projectSettings"] = 0] = "projectSettings";
    VersionSource[VersionSource["teamsapp"] = 1] = "teamsapp";
    VersionSource[VersionSource["unknown"] = 2] = "unknown";
    VersionSource[VersionSource["settings"] = 3] = "settings";
})(VersionSource || (exports.VersionSource = VersionSource = {}));
//# sourceMappingURL=versionMetadata.js.map